export enum RouteOrientationType {
    ONE_WAY = 1, //ida
    RETURN = 2,   //vuelta
    CIRCULAR = 3  //circular
}